/**
 * tracking.js
 */

import React from 'react';
import {
  Box,
} from '@mui/material';
import FeatureBox from 'components/feature-box';
import { UserContext } from 'contexts/user/user-context';
import { MapContext } from '../map/map-context';
import TrackingMap from '../map/tracking-map';
import { DRAWER_TYPE } from '../input-drawers/control-common';
import ControlDrawer from '../input-drawers/control-drawer';
import MarkerDrawer from '../input-drawers/marker-drawer';
import SelectedPointDrawer from '../input-drawers/selected-point-drawer';
import { LiveTrackingContext } from './live-tracking-context';
import { TrackingFormContext } from './tracking-form-context';
import TrackHelpDialog from './track-help-dialog';


export default function Tracking(props) {
  const { user } = React.useContext(UserContext);
  const { currentLocation } = React.useContext(LiveTrackingContext);
  const { selectedPoint, selectedMarkerUuid } = React.useContext(MapContext);
  const { availableLeadTracks } = React.useContext(TrackingFormContext);
  const isLoading = !currentLocation || (user && user.role.isHandler && !availableLeadTracks);
  const activeDrawer = selectedPoint
    ? DRAWER_TYPE.POINT
    : selectedMarkerUuid !== null
      ? DRAWER_TYPE.MARKER
      : DRAWER_TYPE.CONTROL;


  return (
    <>
      <FeatureBox loading={isLoading} spinnerSize={60} style={{ height: '100%' }}>
        <Box sx={{ height: 1, overflow: 'hidden' }}>
          <TrackingMap />
          <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, }}>
            <ControlDrawer 
              isActive={activeDrawer === DRAWER_TYPE.CONTROL}
              disableLoadingUI={isLoading}
            />
            <SelectedPointDrawer
              isActive={activeDrawer === DRAWER_TYPE.POINT}
              disableLoadingUI={isLoading}
            />
            <MarkerDrawer
              key={selectedMarkerUuid}
              isActive={activeDrawer === DRAWER_TYPE.MARKER}
              disableLoadingUI={isLoading}
            />
          </Box>
        </Box>
      </FeatureBox>
      <TrackHelpDialog />
    </>
  );
}